import { createSelector, createStructuredSelector } from 'reselect';
import { purePageSelector as selectPage } from 'src/selectors/page';
import { PAGE_NAME } from './constants';

const speedtestPageSelector = selectPage(PAGE_NAME);

const skusSelector = createSelector(
  speedtestPageSelector,
  (page) => page.skus,
);

const isSpeedtestCompleteSelector = createSelector(
  speedtestPageSelector,
  (page) => page.isSpeedtestComplete,
);

export default createStructuredSelector({
  skus: skusSelector,
  isSpeedtestComplete: isSpeedtestCompleteSelector,
});
